import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import Helmet from "react-helmet";
import styled from "styled-components";

import "./layout.css";
require("prismjs/themes/prism-twilight.css");

const Wrapper = styled.div`
  margin: 1.45rem auto;
  max-width: 60%;
  padding: 1rem;
  background-color: ##242526;
  @media (max-width: 500px) {
    max-width: 95%;
  }
  @media (min-width: 501px) and (max-width: 800px) {
    max-width: 90%;
  }
  @media (max-width: 500px) {
    padding: 0;
  }
`;

const Header = ({ className, children }) => (
  <div className={className}>{children}</div>
);

const StyledHeader = styled(Header)`
  text-align: right;
  color: red;
`;

const TemplateWrapper = ({ children }) => (
  <Wrapper>
    <Helmet
      title="Zameer Haq's Blog"
      meta={[
        { name: "description", content: "Blog by Zameer Haq" },
        { name: "keywords", content: "Javascript, React, CSS, CSS-in-JS" }
      ]}
    />
    <StyledHeader>
      <Link to="/">Home</Link>
      <Link to="/about">About</Link>
    </StyledHeader>
    <div>{children}</div>
  </Wrapper>
);

TemplateWrapper.propTypes = {
  children: PropTypes.object
};

export default TemplateWrapper;
